
export const LOCAL_STORAGE_KEY = 'wpPluginAnalyzerSnapshots';
export const GEMINI_MODEL_NAME = "gemini-2.5-flash-preview-04-17";
